import { Box, Circle, Flex, Heading, Img, Text, Wrap } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import chat_Icon from 'Assets/chat_icon.png';
import { getRecruiters, students, data } from 'Components/Chat/contants';
import { ComapanyJobs } from './ComapanyJobs';
import { generateNumberOfArray } from 'helper/helper';
import { getCompanyDetailsAndJobs } from 'services/api';
import { useWindow } from 'hooks/useWindow';
import arrow from 'Assets/arrowLeft.svg';

export const CompanyProfile = ({ id, mobileView, setMobileView }) => {
  const [companyData, setCompanyData] = useState(null);
  const [jobs, setJobs] = useState([]);
  const windowSize = useWindow();
  const fetchCompanyData = async () => {
    try {
      const { data } = await getCompanyDetailsAndJobs(id);
      setCompanyData(data?.user);
      setJobs(data?.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (id) {
      fetchCompanyData();
    }
  }, [id]);
  return (
    <div>
      <Flex
        className={
          !mobileView?.chatBox && !mobileView?.profile ? 'mobile-d-none' : ''
        }
        flexDir={'column'}
        justify={'center'}
        w={mobileView?.profile ? '100%' : '25vw'}
        height={'100%'}
        borderLeft={
          !mobileView?.chatList && windowSize < 500
            ? 'none'
            : '1px solid #E4E4E4'
        }
        m={'auto'}
      >
        {/* Title */}
        <Flex
          align={'center'}
          //   my={4}
          px={6}
          gap={2}
          height={'87px'}
          borderBottom='1px solid #E4E4E4'
        >
          {windowSize < 500 && (
            <Img
              src={arrow}
              width={30}
              onClick={() => {
                setMobileView((prev) => ({ ...prev, profile: false }));
              }}
            />
          )}
          <Text
            fontSize={24}
            fontFamily={'Epilogue'}
            color={'#544D5E'}
            fontWeight={700}
            mt={1}
          >
            Company Profile
          </Text>
        </Flex>

        {/* Tabs */}

        {!companyData && (
          <Flex height={'90vh'} padding={'10px'}>
            <Heading variant={'h6'} padding={'10px'} size={'md'}>
              {' '}
              Select a company to view profile
            </Heading>
          </Flex>
        )}
        {/* chatlist */}
        {companyData && (
          <Flex
            flexDir={'column'}
            h={'90vh'}
            css={{
              '::-webkit-scrollbar': {
                width: 0,
                height: 0,
              },
            }}
            overflow={'auto'}
            gap={2}
            px={4}
          >
            <Box>
              <Flex>
                <Heading
                  paddingTop={2}
                  size={'md'}
                  color={'#4E4E4E'}
                  fontWeight={'500'}
                  fontFamily={'Roboto'}
                  fontSize={'18px'}
                >
                  Posted By:
                </Heading>
              </Flex>
              <Flex
                align='center'
                gap={2}
                my={5}
                border={'1px solid #DDDDDD'}
                padding={2}
                borderRadius={15}
              >
                <Flex
                  border={'1px solid #DDDDDD'}
                  className='radius-50'
                  padding={1}
                >
                  <img
                    src={companyData?.profile_photo}
                    alt='company'
                    className='radius-50'
                    style={{
                      width: '51px',
                      height: '51px',
                      objectFit: 'cover',
                    }}
                  />
                </Flex>
                <Flex direction='column'>
                  <Text
                    textAlign={'left'}
                    color={'#6D6675'}
                    fontWeight={'bold'}
                    textTransform={'capitalize'}
                  >
                    {/* {postData?.createdBy.name} */}
                    {companyData?.name}
                  </Text>
                  <Flex>
                    <Text color={'#6D6675'} textAlign={'left'}>
                      {/* {postData?.createdBy?.jobTitle || "HR Manager"} */}
                      {companyData?.jobTitle || 'HR Manager'}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </Box>
            <Box>
              <Flex>
                <Heading
                  paddingTop={2}
                  size={'md'}
                  color={'#4E4E4E'}
                  fontWeight={'500'}
                  fontFamily={'Roboto'}
                  fontSize={'18px'}
                >
                  About Company:
                </Heading>
              </Flex>
              <Box border={'1px solid #DDDDDD'} borderRadius={15} my={5}>
                <Flex align='center' gap={2} padding={2}>
                  <Flex align={'center'} gap={'12px'}>
                    <Circle size={14} p={1} border={'1px solid #DDDDDD'}>
                      <img
                        src={companyData?.companyId?.profilePhoto}
                        alt='company'
                        className='radius-50'
                        style={{
                          width: '51px',
                          height: '51px',
                          objectFit: 'cover',
                        }}
                      />
                    </Circle>
                    <Flex direction='column' px={1}>
                      <Text
                        textAlign={'left'}
                        color={'#000'}
                        fontWeight={600}
                        fontSize={18}
                        fontFamily={'Roboto'}
                        textTransform={'capitalize'}
                      >
                        {/* {postData?.companyID.companyName} */}
                        {companyData?.companyId?.companyName}
                      </Text>
                      <Text textAlign={'left'} color={'#6D6675'}>
                        {/* {postData?.companyID?.companyAddress} */}
                        {companyData?.companyId?.companyAddress
                          ?.split('_')
                          ?.join(' ')}
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>
                <Flex>
                  <Text
                    color={'#6D6675'}
                    textAlign={'left'}
                    width={'100%'}
                    p={2}
                    px={4}
                  >
                    {/* {postData?.companyID?.bio} */}
                    {companyData?.companyId?.bio}
                  </Text>
                </Flex>
              </Box>
            </Box>
            <Box>
              <Flex>
                <Heading
                  paddingTop={2}
                  size={'md'}
                  color={'#4E4E4E'}
                  fontWeight={'500'}
                  fontFamily={'Roboto'}
                  fontSize={'18px'}
                >
                  Other Jobs:
                </Heading>
              </Flex>
              {jobs?.map((item, index) => (
                <ComapanyJobs
                  item={item}
                  recruiter={companyData?.name}
                  image={companyData?.companyId?.profilePhoto}
                />
              ))}
            </Box>
          </Flex>
        )}
      </Flex>
    </div>
  );
};
